import React, { useState, useRef } from "react";
import cogoToast from "cogo-toast";

const MagnifiableImage = ({ height, width, src, alt, zoomFactor = 2.5 }) => {
    const imageRef = useRef()
    const containerRef = useRef()
    const [zoom, setZoom] = useState(1);
    const [[top, left], setRelativePosition] = useState([0, 0]);

    /* Loading Image State */
    const [imageLoaded, setImageLoaded] = useState(false);

    // Display notification when image loading failed 
    const imageLoadError = e => {
        if (src) {
            cogoToast.error("Unable to load Image");
            setImageLoaded(true);
        }
    }

    return (
        <a
            href={src ?? "#"}
            target="_blank"
            rel="noreferrer"
            className="text-black font-weight-bold"
        >
            <div
                ref={containerRef}
                style={{
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: height,
                    width: width,
                }}
                onMouseEnter={(e) => {
                    // start magnifying
                    setZoom(zoomFactor);
                }}
                onMouseMove={(e) => {
                    const { top, left, width, height } = containerRef.current.getBoundingClientRect();
                    const { width: imgWidth, height: imgHeight } = imageRef.current.getBoundingClientRect();

                    // calculate cursor position relative to container
                    const x = e.clientX - left;
                    const y = e.clientY - top;

                    // calculate image position relative to container
                    const widthDelta = imgWidth - width;
                    const heightDelta = imgHeight - height;
                    const imgLeft = (x / width) * -widthDelta;
                    const imgTop = (y / height) * -heightDelta;

                    setRelativePosition([imgTop, imgLeft]);
                }}
                onMouseLeave={() => {
                    // stop magnifying
                    setZoom(1);
                }}
            >
                <div
                    className="py-2 px-4 m-3 bg-light text-black font-weight-bold rounded-xl opacity-75"
                    style={{
                        left: 0,
                        bottom: 0,
                        position: "absolute",
                        pointerEvents: "none",
                        zIndex: 1,
                    }}
                >
                    Hover to zoom
                </div>
                <div className={`spinner-border mx-5 text-primary ${imageLoaded ? "d-none" : ""}`} style={{ width: "4rem", height: "4rem", borderWidth: "0.1rem" }} role="status">
                    <span className="sr-only">Loading...</span>
                </div>
                <img
                    ref={imageRef}
                    width={`${100 * zoom}%`}
                    height={`${100 * zoom}%`}
                    className={`${imageLoaded ? "" : "d-none"}`}
                    style={{
                        position: "absolute",
                        objectFit: "contain",
                        ...(zoom === 1) ? {} : { top },
                        ...(zoom === 1) ? {} : { left },
                    }}
                    onLoad={_ => setImageLoaded(true)}
                    onError={imageLoadError}
                    src={src}
                    alt={alt}
                />
            </div>
        </a>
    );
};

export default MagnifiableImage;